import React from 'react';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { Paper } from '@material-ui/core';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { neutralNr30 } from 'common/colors';

const BoxEOD = () => {
  const useStyles = makeStyles({
    cardEOD: {
      borderRadius: '12px',
      padding: '16px',
      border: '1px solid',
      borderColor: neutralNr30
    },
    titleCardFitur: {
      fontSize: '14px',
      fontFamily: 'Lato',
      fontWeight: 700,
      lineHeight: '24px'
    }
  });

  const classes = useStyles();

  return (
    <Paper className={classes.cardEOD} elevation={0}>
      <Grid alignItems="center" container direction="column" spacing={1}>
        <Grid item>
          <img
            alt="EOD"
            src="/images/assets/eod.svg"
            style={{ display: 'block', margin: '0 auto' }}
          />
        </Grid>

        <Grid item>
          <Typography className={classes.titleCardFitur}>
            Sedang ada pemeliharaan rutin..
          </Typography>
        </Grid>

        <Grid container direction="column" item>
          <Typography
            align="center"
            style={{ maxWidth: 320 }}
            variant="caption"
          >
            Demi kenyamananmu, saat ini sedang dilakukan pemeliharaan rutin.
            Kembali lagi nanti, ya.
          </Typography>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default BoxEOD;
